module.exports = __webpack_public_path__ + "img/vertikal.91e016e2.svg";